// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__W8761","clinicsSelect":"TableHeading_clinicsSelect__aSdok"};